// Here are some simple helper functions to get you started.
// These will make it simpler to get environment variables or
// check the environment within your components or elsewhere.

export const getEnvVar = (name) => process.env[name];

export const getEnv = () => getEnvVar('REACT_APP_ENV');
export const isEnv = (env) => env === getEnv();
